export const APP_TYPE = 'REG_FORM';
export const RESEND_OTP_TIME = 30;

export enum GENDER_ENUM {
  M = 'M',
  F = 'F',
  X = 'X',
  U = 'U',
}

export const GENDER_OPTIONS = [
  {
    label: 'MALE',
        value: GENDER_ENUM.M,
  },
  {
    label: 'FEMALE',
    value: GENDER_ENUM.F,
  },
  // {
  //   label: 'DIVERSE',
  //   value: GENDER_ENUM.X,
  // },
  // {
  //   label: 'PREFER_NOT_TO_SAY',
  //   value: GENDER_ENUM.U,
  // },
];


export const GENDER_ENUM_TRANSLATIONS: Dict<string, GENDER_ENUM> = {
    [GENDER_ENUM.M]: 'MALE',
    [GENDER_ENUM.F]: 'FEMALE',
    [GENDER_ENUM.X]: 'DIVERSE',
    [GENDER_ENUM.U]: 'PREFER_NOT_TO_SAY',
  };
